/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Reportingapikeys_Column_Keyname_Tooltip3Inputs */

const en_settings_reportingapikeys_column_keyname_tooltip3 = /** @type {(inputs: Settings_Reportingapikeys_Column_Keyname_Tooltip3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unique name of the key per user. Generating a key under an existing name replaces that key.`)
};

/**
* | output |
* | --- |
* | "Unique name of the key per user. Generating a key under an existing name replaces that key." |
*
* @param {Settings_Reportingapikeys_Column_Keyname_Tooltip3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_reportingapikeys_column_keyname_tooltip3 = /** @type {((inputs?: Settings_Reportingapikeys_Column_Keyname_Tooltip3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Reportingapikeys_Column_Keyname_Tooltip3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_reportingapikeys_column_keyname_tooltip3(inputs)
});
export { settings_reportingapikeys_column_keyname_tooltip3 as "settings_reportingApiKeys_column_keyName_tooltip" }